<template>
    <div class="order-items-table epro-version">
        <div class="items-container">
            <!-- Header row (thead-like) -->
            <div class="table-head row item-separador-header align-items-center">
                <div class="col-3 itemAndDescrip" style="padding-left: 15px;"><strong>{{ lang.bsoit_product_service }} {{ taxShow }}</strong></div>
                <div class="col-1 text-right"><strong>{{ lang.bsoit_qty }}</strong></div>
                <div class="col-2 text-right"><strong>{{ lang.bs_price }}</strong></div>
                <div class="col-2 taxselect text-center" ><strong>{{ lang.bs_tax }}</strong></div>
                <div class="col-2 text-right"><strong>{{ lang.bs_total }}</strong></div>
            </div>

            <draggable v-model="localItems" tag="div" class="items-list" :options="dragOptions" @start="onDragStart" @end="onDragEnd" handle=".handle">
                <div v-for="(item, index) in localItems" :key="item._uid || item.product_id || index" :class="['tr-products', 'item-porduct-' + index, 'order-item-row']">
                    <div class="btnmove handle" style="line-height:50px;"><iconoMove /></div>

                    <!-- Row 1: Product | Quantity | Price | Total (single row) -->
                    <div class="row item-separador-header align-items-center">
                        <div class="col-5 itemAndDescrip">
                            <model-select :options="productsOptions" v-model="localItems[index].product_id" :placeholder="lang.bsoit_choose_product_ph" class="productos" @input="(val) => onSelectProduct(index, val)"></model-select>
                        </div>
                        <div class="col-1">
                            <quantityInput :disabledSteps="propdisabledSteps" :valueProp="localItems[index].quantity" @input="val => setQty(val, index)" />
                        </div>
                        <div class="col-2">
                            <costUnitInput :disabledSteps="propdisabledSteps" :valueProp="localItems[index].price" @input="val => setCostUnit(val, index)" />
                        </div>
                        <!-- <div class="col-2 taxselect">
                            <select class="form-control" v-model="localItems[index].taxOpc" @change="e => setTax(e.target.value, index)">
                                <option v-for="(t, taxIdx) in taxlistOption" :key="taxIdx" :value="t.value">{{ t.name }}</option>
                            </select>
                        </div> -->
                        <div class="col-2 text-right">
                            <div class="form-control-plaintext">{{currency}} {{ formatNumber(localItems[index].total) | formatMoney }}</div>
                        </div>
                    </div>

                    <!-- Row 2: Description full width -->
                    <div class="row mt-2">
                        <div class="col-12 descripcion">
                            <tbDescription v-model="localItems[index].note_item" :limit="numberWordsProDes" limit-type="words" editor-class="prod_description" error-class="text-error" :placeholder="lang.bsoit_product_note_ph" :readonly="false" :emitOnLimitReached="true" @limit-reached="onLimitReached" />
                        </div>
                    </div>

                    <div class="btndelete" @click.stop="removeItem(index)">x</div>
                </div>
            </draggable>

            <div class="mt-2">
                <button class="btn btn-info btn-sm" @click.prevent="addItem">{{ lang.bsoit_add_product }}</button>
            </div>
        </div>
    </div>
</template>
<script>
import './OrderItemsTable.editor.scss';
import { mapGetters } from "vuex";
import draggable from 'vuedraggable';
import { ModelSelect } from 'vue-search-select';
import iconoMove from '@/apps/billing/components/estpro/secForm/tbProducts/iconoMove.vue';
import tbDescription from '@/apps/billing/components/RichTextEditor.vue';
import quantityInput from '@/apps/billing/components/estpro/secForm/tbProducts/quantityInput.vue';
import costUnitInput from '@/apps/billing/components/estpro/secForm/tbProducts/costUnitInput.vue';

export default {
    name: 'OrderItemsTableV2',
    components: { draggable, ModelSelect, iconoMove, tbDescription, quantityInput, costUnitInput },
    props: {
        items: { type: Array, default: () => [] },
        productosGrouped: { type: Array, default: () => [] },
        propdisabledSteps: { type: Object, default: () => ({}) },
        propgroupShow: { type: [Number, String], default: 0 },
        proptaxShow: { type: [Boolean, Number], default: false },
        taxesPercent: { type: Number, default: 0 },
    },
    data() {
        return {
            lang: {
                bsoit_product_service: '',
                bsoit_qty: '',
                bs_price: '',
                bs_tax: '',
                bs_total: '',
                bsoit_choose_product_ph: '',
                bsoit_product_note_ph: '',
                bsoit_add_product: '',
                bsoit_none: '',
            },
            localItems: (this.items || []).map(i => ({ ...i })),
            editorOptions: { modules: { toolbar: [ ['bold'], [{ color: [] }], [{ list: 'bullet' }] ] } },
            numberWordsProDes: 220,
            taxlistOption: [{value: 0, name: 'None'}], // example tax options; replace with real data as needed
            taxShow: this.proptaxShow || false,
            groupShow: Number(this.propgroupShow) || 0,
            activeKey: null,
            dragOptions: { animation: 150, handle: '.handle' },
            apis: null, // to store API endpoints
        };
    },
    watch: {
        langGetter() {
            this.lang = this.$store.getters['ModApps/Marketea/lang'];
        },
        items: { handler(newVal) { this.localItems = (newVal || []).map(i => ({ ...i })); this.ensureHasItem(); }, deep: true, immediate: true }
    },
    mounted() {
        this.lang = this.$store.getters['ModApps/Marketea/lang'];
        if(this.taxesPercent){
            this.taxlistOption = [
                { value: 0, name: this.lang.bsoit_none || 'None', initialstate: '' },
                { value: this.taxesPercent, name: `${this.lang.bs_tax} ${this.taxesPercent}%`},
            ];
        }
        console.log('items', this.items);
        this.ensureHasItem()
    },
    computed: {
        ...mapGetters("ModApps/Marketea/", {
            currency: "get_bStore_currency",
            langGetter: "lang",
        }),
        productsOptions() {
            const groups = this.productosGrouped || [];
            return groups.flatMap(g => (g.products || []).map(p => ({ value: p.id, text: p.product_name, price: p.price, product_name: p.product_name })));
        }
    },
    methods: {
        addItemAt(index) { const newItem = { product_id: null, product_name: '', price: 0, quantity: 1, taxOpc: 0, total: 0, note_item: '', _selected: null }; this.localItems.splice(index + 1, 0, newItem); this.emitGroupedItems(); },
        ensureHasItem() { if (!this.localItems || this.localItems.length === 0) this.addItem(); },
        setActive(idx, item) { const key = item && (item._uid || item.product_id || `item_${idx}`); this.activeKey = key; },
        isActive(item) { const key = item && (item._uid || item.product_id || null); return key && this.activeKey === key; },
        formatNumber(val) { return (Number(val) || 0).toFixed(2); },
        onDragStart() {},
        onDragEnd() { this.emitGroupedItems(); },
        emitGroupedItems() { this.$emit('update-items', (this.localItems || []).map(i => ({ ...i }))); },
        addItem() { const newItem = { product_id: null, product_name: '', price: 0, quantity: 1, taxOpc: 0, total: 0, note_item: '', _selected: null }; this.localItems.push(newItem); this.emitGroupedItems(); },
        removeItem(index) { this.localItems.splice(index, 1); this.emitGroupedItems(); },
        setQty(val, index) { const it = this.localItems[index]; it.quantity = Number(val) || 0; this.onItemChangeGrouped(index); },
        setCostUnit(val, index) { const it = this.localItems[index]; it.price = Number(val) || 0; this.onItemChangeGrouped(index); },
        // setTax(val, index) { const it = this.localItems[index]; it.taxOpc = Number(val) || 0; this.onItemChangeGrouped(index); },
        onItemChangeGrouped(index) { const it = this.localItems[index]; if (!it) return; it.price = Number(it.price) || 0; it.quantity = Number(it.quantity) || 0; it.taxOpc = Number(it.taxOpc) || 0; it.total = Number((it.price * it.quantity).toFixed(2)); this.emitGroupedItems(); },
        onSelectProduct(index, selected) {
            if (selected === null || typeof selected === 'undefined') return;
            const it = this.localItems[index]; if (!it) return;
            let sel = selected;
            if (typeof sel !== 'object' || !('value' in sel)) {
                const opts = this.productsOptions || [];
                const found = opts.find(o => o.value === sel) || null;
                if (found) sel = found; else sel = { value: sel, text: String(sel), price: 0, product_name: String(sel) };
            }
            it._selected = sel; it.product_id = sel.value; it.product_name = sel.product_name || sel.text || ''; it.price = Number(sel.price || 0); it.quantity = Number(it.quantity) || 1; it.taxOpc = Number(it.taxOpc) || 0; it.total = Number((it.price * (Number(it.quantity) || 0)).toFixed(2)); this.emitGroupedItems();
        },
        onLimitReached(payload) { /* noop for now; placeholder */ },

    },
};
</script>

<style scoped>
/* Handler, layout and description styles adapted from table_ePro */
.order-items-table.epro-version .order-item-row,
.order-items-table.epro-version .tr-products {
    padding: 8px 0;
    border-bottom: 1px solid #eee;
    position: relative;
    transition: background-color .18s ease, border-color .18s ease, box-shadow .18s ease, transform .12s ease;
}

.order-items-table.epro-version .btnmove {
    cursor: grab;
    position: absolute;
    left: 8px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 5;
    font-size: 18px;
}

.order-items-table.epro-version .handle {
    cursor: grab;
}

.order-items-table.epro-version .itemAndDescrip {
    position: relative;
    padding-left: 0px;
    padding-right: 0;
}

/* Layout adjustments to emulate table symmetry while using divs */
.order-items-table.epro-version .items-list .tr-products {
    position: relative;
    padding: 12px 12px;
}

.order-items-table.epro-version .btnAddItem {
    position: absolute;
    left: 48px;
    top: 50%;
    transform: translateY(-50%);
    margin: 0;
}

.order-items-table.epro-version .item-separador-header {
    display: flex;
    align-items: center;
    gap: 12px;
}

.order-items-table.epro-version .item-separador-header .col-8 {
    padding-left: 88px; /* reserve space for handle + add button */
}

.order-items-table.epro-version .item-separador-header .col-4 {
    display: flex;
    align-items: center;
}

.order-items-table.epro-version .item-continue-description {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
}

.order-items-table.epro-version .item-continue-description .col-3 {
    flex: 0 0 120px;
    max-width: 120px;
}

.order-items-table.epro-version .taxselect .form-control {
    max-width: 220px;
}

.order-items-table.epro-version .descripcion {
    margin-top: 8px;
    padding-left:0 ;
}

.order-items-table.epro-version .descripcion .prod_description,
.order-items-table.epro-version .descripcion .ql-container {
    width: 100%;
    max-height: 100px;
    height: 100px;
    overflow: auto;
}

.order-items-table.epro-version .btnAddItem {
    margin-right: 8px;
    margin-left: 40px;
    display: inline-block;
    vertical-align: middle;
}

.order-items-table.epro-version .productos,
.order-items-table.epro-version .vs__search {
    width: 100%;
}

.order-items-table.epro-version .importe {
    position: relative;
    text-align: right;
}

.order-items-table.epro-version .btndelete {
    position: absolute;
    top: 8px;
    right: 8px;
    display: inline-block;
    padding: 6px;
    background-color: #f12e2e;
    cursor: pointer;
    font-size: 18px;
    color: #fff;
    text-align: center;
    line-height: 1;
    border-radius: 4px;
    transition: background-color .12s ease, transform .12s ease;
}

.order-items-table.epro-version .btndelete:hover {
    background-color: #c12727;
    transform: translateY(-1px);
}

/* Drag classes for vuedraggable */
.order-items-table.epro-version .item-chosen {
    opacity: 0.95;
}

.order-items-table.epro-version .item-drag {
    transform: scale(1.02);
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12);
}

.order-items-table.epro-version .item-ghost {
    opacity: 0.45;
}

.order-items-table.epro-version .item-transition-move {
    transition: transform .18s ease;
}

/* Limit vue2-editor height inside this component only and enable internal scrolling */
.order-items-table.epro-version>>>.vue-editor .ql-container,
.order-items-table.epro-version ::v-deep .vue-editor .ql-container {
    max-height: 100px;
    height: 100px;
    overflow: auto;
}

.order-items-table.epro-version>>>.vue-editor .ql-editor,
.order-items-table.epro-version ::v-deep .vue-editor .ql-editor {
    min-height: 100px;
    max-height: 100px;
    overflow: auto;
}
</style>
